/* eslint-disable react/no-unescaped-entities */
import React, { useState } from "react";
import "./Testimonials.scss";
import "keen-slider/keen-slider.min.css";
import { useKeenSlider } from "keen-slider/react";

function Testimonials() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const [sliderRef, instanceRef] = useKeenSlider(
    {
      initial: 0,
      loop: true,
      renderMode: "performance",
      drag: true,
      slideChanged(slider) {
        setCurrentSlide(slider.track.details.rel);
      },
      created() {
        setLoaded(true);
      },
    },
    [
      (slider) => {
        let timeout;
        let mouseOver = false;
        function clearNextTimeout() {
          clearTimeout(timeout);
        }
        function nextTimeout() {
          clearTimeout(timeout);
          if (mouseOver) return;
          timeout = setTimeout(() => {
            slider.next();
          }, 4000);
        }
        slider.on("created", () => {
          slider.container.addEventListener("mouseover", () => {
            mouseOver = true;
            clearNextTimeout();
          });
          slider.container.addEventListener("mouseout", () => {
            mouseOver = false;
            nextTimeout();
          });
          nextTimeout();
        });
        slider.on("dragStarted", clearNextTimeout);
        slider.on("animationEnded", nextTimeout);
        slider.on("updated", nextTimeout);
      },
    ]
  );
  return (
    <div className="testimonials-wrap">
      <div className="t-inner keen-slider" ref={sliderRef}>
        <div className="t-items keen-slider__slide">
          <h6>
            "They are very good event organisers and make sure to live up to the
            customer's standards".
          </h6>
          <p>
            <em>By:- Kavya & Ayush</em>
          </p>
        </div>
        <div className="t-items keen-slider__slide">
          <h6>
            They transformed our venue into a magical wonderland, exceeding our
            expectations and creating an unforgettable experience.
          </h6>
          <p>
            <em>By:- Nishant Gupta</em>
          </p>
        </div>
        <div className="t-items keen-slider__slide">
          <h6>
            "In simple words wowWishMoments have a ability to capture our vision
            and execute it flawlessly made our celebration truly remarkable".
          </h6>
          <p>
            <em>By:-Aamisha</em>
          </p>
        </div>
        <div className="t-items keen-slider__slide">
          <h6>
            "Their expertise in coordinating colors, fabrics, and lighting
            created a visually stunning atmosphere that impressed all
            attendees".
          </h6>
          <p>
            <em>By:- Mitali </em>
          </p>
        </div>
      </div>
      {loaded && instanceRef.current && (
        <div className="dots">
          {[
            ...Array(instanceRef.current.track.details.slides.length).keys(),
          ].map((idx) => {
            return (
              <button
                key={idx}
                onClick={() => {
                  instanceRef.current?.moveToIdx(idx);
                }}
                className={"dot" + (currentSlide === idx ? " active" : "")}
              ></button>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default Testimonials;
